import React from "react";
import { useSelector, useDispatch } from "react-redux";
// import { Button, Radio } from "antd";
// import { SearchOutlined } from "@ant-design/icons";
import {
  setRepairDetail,
  setCenterMap,
} from "../../../../actions/boldgroup/repairPointAction";
import { numericInput } from "../../../../utils/utils";

const CreateRepairCoreDetail = ({ item, index }) => {
  const { repairDetail, devicesOdfMdf } = useSelector((state) => ({
    repairDetail: state.repairPoint?.repairDetail,
    devicesOdfMdf: state.repairPoint?.devicesOdfMdf,
  }));
  const dispatch = useDispatch();

  // const [selectDevice, setSelectDevice] = useState(null);

  const handleSetMarkerDetail = (index, key, value) => {
    dispatch(
      setRepairDetail({
        ...repairDetail,
        markers: repairDetail.markers.map((s, i) => {
          if (i === index) {
            return { ...s, [key]: value };
          }
          return s;
        }),
      })
    );
  };

  const handleSetCenterMap = (location) => {
    dispatch(setCenterMap(location));
  };

  return (
    <div className="row">
      <div className="col-6">
        <div className="form-group">
          <label className="mb-0">Latitude</label>
          <input
            className="form-control form-control-sm"
            value={item.latitude || ""}
            onChange={(event) => {
              const { value } = event.target;
              handleSetMarkerDetail(index, "latitude", numericInput(value));
            }}
            disabled
          />
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <label className="mb-0">Longitude</label>
          <input
            className="form-control form-control-sm"
            value={item.longitude || ""}
            onChange={(event) => {
              const { value } = event.target;
              handleSetMarkerDetail(index, "longitude", numericInput(value));
            }}
            disabled
          />
        </div>
      </div>
      {/* {!!item.latitude && !!item.longitude && (
        <div className="col-12 text-center">
          <Button
            className="btn-search-repair-point"
            shape="round"
            icon={<SearchOutlined />}
            onClick={() =>
              handleSetCenterMap({
                lat: +item.latitude,
                lng: +item.longitude,
              })
            }
          >
            Search
          </Button>
        </div>
      )} */}
      <div className="col-12">
        <div className="form-group">
          <label className="mb-0">Site/Node/Cust</label>
          <input
            className="form-control form-control-sm"
            value={item.siteName || ""}
            onChange={(event) => {
              const { value } = event.target;
              handleSetMarkerDetail(index, "siteName", value);
            }}
          />
          {/* <select
            className="form-control form-control-sm"
            value={item.pkId || ""}
            onChange={(event) => {
              const { value } = event.target;
              const device = devicesOdfMdf.find((s) => s.obj_id === +value);
              dispatch(
                setRepairDetail({
                  ...repairDetail,
                  markers: repairDetail.markers.map((s, i) => {
                    if (i === index) {
                      return {
                        ...s,
                        pkId: value,
                        fiberTypeID: `${device.obj_type} - ${device.obj_label}`,
                        beforeCore: 0,
                        afterCore: 0,
                      };
                    }
                    return s;
                  }),
                })
              );
              setSelectDevice(device);
            }}
          >
            <option value="">โปรดเลือก</option>
            {devicesOdfMdf.map((device, i) => (
              <option key={i} value={device.obj_id}>
                {`${device.obj_type} - ${device.obj_label}`}
              </option>
            ))}
          </select> */}
        </div>
      </div>
      <div className="col-12">
        <div className="form-group">
          <label className="mb-0">ระยะทางจาก Site - จุดที่มีปัญหา(เมตร)</label>
          <input
            className="form-control form-control-sm"
            value={item.distanceRepairPoint || ""}
            onChange={(event) => {
              const { value } = event.target;
              handleSetMarkerDetail(
                index,
                "distanceRepairPoint",
                numericInput(value)
              );
            }}
          />
        </div>
      </div>
      <div className="col-12">
        <div className="form-group">
          <label className="mb-0">บริเวณจุดเสีย หรือ อื่นๆ</label>
          <textarea
            className="form-control form-control-sm"
            value={item.remark || ""}
            onChange={(event) => {
              const { value } = event.target;
              handleSetMarkerDetail(index, "remark", value);
            }}
          />
        </div>
      </div>
      {/* <div className="col-12">
        <div className="form-group">
          <Radio.Group
            onChange={(event) => {
              const { value } = event.target;
              dispatch(
                setRepairDetail({
                  ...repairDetail,
                  markers: repairDetail.markers.map((s, i) => {
                    if (i === index) {
                      return {
                        ...s,
                        direction: value,
                        beforeCore: 0,
                        afterCore: 0,
                      };
                    }
                    return s;
                  }),
                })
              );
            }}
            value={item.direction}
          >
            <Radio value={"from"}>ขาเข้า</Radio>
            <Radio value={"to"}>ขาออก</Radio>
          </Radio.Group>
        </div>
      </div> */}
      <div className="col-12">
        <div className="form-group">
          <label className="mb-0">ตำแหน่ง Core เดิม</label>
          <input
            className="form-control form-control-sm"
            value={item.beforeCore || ""}
            onChange={(event) => {
              const { value } = event.target;
              handleSetMarkerDetail(index, "beforeCore", numericInput(value));
            }}
          />
          {/* <select
            className="form-control form-control-sm"
            value={item.beforeCore || ""}
            onChange={(event) => {
              const { value } = event.target;
              handleSetMarkerDetail(index, "beforeCore", value);
            }}
          >
            <option value="">โปรดเลือก</option>
            {selectDevice?.fullPort.map((port, i) => (
              <option key={i} value={`${port}`}>
                {port}
              </option>
            ))}
          </select> */}
        </div>
      </div>
      <div className="col-12">
        <div className="form-group">
          <label className="mb-0">ตำแหน่ง Core ใหม่</label>
          <input
            className="form-control form-control-sm"
            value={item.afterCore || ""}
            onChange={(event) => {
              const { value } = event.target;
              handleSetMarkerDetail(index, "afterCore", numericInput(value));
            }}
          />
          {/* <select
            className="form-control form-control-sm"
            value={item.afterCore || ""}
            onChange={(event) => {
              const { value } = event.target;
              handleSetMarkerDetail(index, "afterCore", value);
            }}
          >
            <option value="">โปรดเลือก</option>
            {selectDevice?.emptyPort.map((port, i) => (
              <option key={i} value={`${port}`}>
                {port}
              </option>
            ))}
          </select> */}
        </div>
      </div>
    </div>
  );
};

export default CreateRepairCoreDetail;
